import { getThemeName, ThemeNames } from '../utils/dist/commons.esm.js';

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/**
 * Base Colours v3
 */
// Interactive
var ultramarine = {
  900: {
    value: '#171b3d'
  },
  800: {
    value: '#29337b'
  },
  700: {
    value: '#3645b8'
  },
  600: {
    value: '#3d53f5'
  },
  500: {
    value: '#5e72ff'
  },
  400: {
    value: '#8291ff'
  },
  300: {
    value: '#a9b3ff'
  },
  200: {
    value: '#d3d8ff'
  },
  100: {
    value: '#eaecff'
  },
  50: {
    value: '#f6f7ff'
  },
  25: {
    value: '#fbfbff'
  }
};

// Basic
var transparent = {
  0: {
    value: 'transparent'
  }
};
var white = {
  0: {
    value: '#ffffff'
  }
};
var black = {
  1000: {
    value: '#000000'
  }
};
var green = {
  900: {
    value: '#0d2210'
  },
  800: {
    value: '#18451f'
  },
  700: {
    value: '#21672d'
  },
  600: {
    value: '#288a38'
  },
  500: {
    value: '#2cac41'
  },
  400: {
    value: '#4cc460'
  },
  300: {
    value: '#73dc84'
  },
  200: {
    value: '#a0f4ae'
  },
  100: {
    value: '#c1fecb'
  },
  50: {
    value: '#d9ffdf'
  },
  25: {
    value: '#ecffef'
  }
};
var red = {
  900: {
    value: '#331314'
  },
  800: {
    value: '#662022'
  },
  700: {
    value: '#99282c'
  },
  600: {
    value: '#cc2b30'
  },
  500: {
    value: '#ff282f'
  },
  400: {
    value: '#ff5158'
  },
  300: {
    value: '#ff7f84'
  },
  200: {
    value: '#ffafb2'
  },
  100: {
    value: '#ffcfd1'
  },
  50: {
    value: '#ffe5e6'
  },
  25: {
    value: '#fff3f3'
  }
};
var orange = {
  900: {
    value: '#321e12'
  },
  800: {
    value: '#65391f'
  },
  700: {
    value: '#975027'
  },
  600: {
    value: '#ca6429'
  },
  500: {
    value: '#fc7426'
  },
  400: {
    value: '#ff904f'
  },
  300: {
    value: '#ffac7c'
  },
  200: {
    value: '#ffcbad'
  },
  100: {
    value: '#ffe0ce'
  },
  50: {
    value: '#ffeee4'
  },
  25: {
    value: '#fff7f2'
  }
};

// Feedback
var blue = {
  900: {
    value: '#112431'
  },
  800: {
    value: '#1d4562'
  },
  700: {
    value: '#216393'
  },
  600: {
    value: '#207fc4'
  },
  500: {
    value: '#1898f5'
  },
  400: {
    value: '#42b0ff'
  },
  300: {
    value: '#70c3ff'
  },
  200: {
    value: '#a2d8ff'
  },
  100: {
    value: '#c5e7ff'
  },
  50: {
    value: '#def1ff'
  },
  25: {
    value: '#f0f9ff'
  }
};

/**
 * Base Color v1 (LUI Now)
 */

/**
 * @deprecated LUI-863 To be removed in the next major
 */
var info = _objectSpread2({
  950: {
    value: blue['900'].value,
    deprecated: true,
    deprecated_comment: 'Replace with the "blue" color. Will be removed in next major.'
  }
}, blue);

/**
 * @deprecated LUI-863 To be removed in the next major
 */
var error = _objectSpread2({
  950: {
    value: red['900'].value,
    deprecated: true,
    deprecated_comment: 'Replace with the "red" color. Will be removed in next major.'
  }
}, red);

/**
 * @deprecated LUI-863 To be removed in the next major
 */
var success = _objectSpread2({
  950: {
    value: green['900'].value,
    deprecated: true,
    deprecated_comment: 'Replace with the "green" color. Will be removed in next major.'
  }
}, green);

/**
 @deprecated LUI-863 To be removed in the next major
 */
var warn = _objectSpread2({
  950: {
    value: orange['900'].value,
    deprecated: true,
    deprecated_comment: 'Replace with the "orange" color. Will be removed in next major.'
  }
}, orange);
var base$4 = {
  info,
  error,
  success,
  warn,
  ultramarine,
  transparent,
  white,
  black,
  green,
  red,
  orange,
  blue
};

var color$5 = {
  base: base$4
};

/**
 * Base Colours v3
 */
var purple = {
  900: {
    value: '#1a0d23'
  },
  800: {
    value: '#331745'
  },
  700: {
    value: '#4b1f68'
  },
  600: {
    value: '#633482'
  },
  500: {
    value: '#7d4e9c'
  },
  400: {
    value: '#996db7'
  },
  300: {
    value: '#b791d1'
  },
  200: {
    value: '#d8bbeb'
  },
  100: {
    value: '#e9d5f7'
  },
  50: {
    value: '#f3e6fc'
  },
  25: {
    value: '#faf3fe'
  }
};
var yellow = {
  900: {
    value: '#2b2610'
  },
  800: {
    value: '#55491b'
  },
  700: {
    value: '#806d23'
  },
  600: {
    value: '#aa8f26'
  },
  500: {
    value: '#d4b024'
  },
  400: {
    value: '#ffd11f'
  },
  300: {
    value: '#ffdc51'
  },
  200: {
    value: '#ffe788'
  },
  100: {
    value: '#ffefb1'
  },
  50: {
    value: '#fff6d1'
  },
  25: {
    value: '#fffbe9'
  }
};
var teal = {
  900: {
    value: '#0f241f'
  },
  800: {
    value: '#1c483e'
  },
  700: {
    value: '#286d5e'
  },
  600: {
    value: '#33917d'
  },
  500: {
    value: '#3db59b'
  },
  400: {
    value: '#45d9ba'
  },
  300: {
    value: '#6eedd1'
  },
  200: {
    value: '#9dffea'
  },
  100: {
    value: '#bffff1'
  },
  50: {
    value: '#d8fff7'
  },
  25: {
    value: '#ecfffb'
  }
};
var peach = {
  900: {
    value: '#2b1a12'
  },
  800: {
    value: '#553223'
  },
  700: {
    value: '#804b34'
  },
  600: {
    value: '#aa6345'
  },
  500: {
    value: '#d47b56'
  },
  400: {
    value: '#ff9366'
  },
  300: {
    value: '#ffb18f'
  },
  200: {
    value: '#ffd0bc'
  },
  100: {
    value: '#ffe4d9'
  },
  50: {
    value: '#fff0ea'
  },
  25: {
    value: '#fff8f5'
  }
};
var grey$2 = {
  900: {
    value: '#1d1d1d'
  },
  800: {
    value: '#3a3a39'
  },
  700: {
    value: '#575756'
  },
  600: {
    value: '#737372'
  },
  500: {
    value: '#8f8f8e'
  },
  400: {
    value: '#ababa9'
  },
  300: {
    value: '#c7c7c5'
  },
  200: {
    value: '#e4e4e2'
  },
  100: {
    value: '#f2f2f0'
  },
  50: {
    value: '#f8f8f6'
  },
  25: {
    value: '#fcfcf9'
  }
};

/**
 * Base Color v1 (LUI Now compatible)
 * @deprecated use `grey` instead. LUI-863 To be removed in the next major
 */
var shade$3 = _objectSpread2(_objectSpread2({
  1000: {
    value: '#000000'
  },
  950: {
    value: '#0B0B0B'
  }
}, grey$2), {}, {
  0: {
    value: '#FFFFFF'
  }
});
var base$3 = {
  purple,
  yellow,
  teal,
  peach,
  grey: grey$2,
  shade: shade$3
};

/**
 * @todo evaulate how 'default' semantic value is being used and migrate away from it
 */
var text$3 = {
  main: base$3.grey[900],
  subtle: base$3.grey[700],
  contrast: base$3.purple[700],
  inverse: base$4.white[0],
  default: base$3.grey[900]
};
var interaction$3 = {
  main: base$3.purple[700],
  subtle: base$4.white[0],
  contrast: base$3.purple[700],
  emphasis: base$3.yellow[400],
  disabled: base$3.grey[400],
  success: base$4.green[600],
  error: base$4.red[600]
};
var fill$3 = {
  main: base$4.white[0],
  contrast: base$3.purple[700],
  accent: base$3.purple[700],
  selected: base$3.purple[50],
  disabled: base$3.grey[50]
};
var background$3 = {
  page: base$3.grey[25],
  container: base$4.white[0],
  surface: base$3.grey[100],
  emphasis: base$3.grey[50]
};
var border$3 = {
  container: base$3.grey[200],
  divider: base$3.grey[100],
  dividerEmphasis: base$3.grey[900],
  interaction: {
    default: base$3.grey[500],
    hover: base$3.grey[700],
    focus: base$4.ultramarine[500],
    selected: base$3.purple[700]
  }
};
var buttonFill$3 = {
  primary: {
    default: base$3.purple[700],
    hover: base$3.purple[600],
    focus: base$3.purple[700],
    disabled: base$3.grey[400],
    pressed: base$3.purple[800]
  },
  primaryInverse: {
    default: base$3.yellow[400],
    hover: base$3.yellow[300],
    focus: base$3.yellow[400],
    disabled: base$3.grey[50],
    pressed: base$3.yellow[500]
  },
  secondary: {
    default: base$4.transparent[0],
    hover: base$3.purple[25],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$3.purple[50]
  },
  secondaryInverse: {
    default: base$4.transparent[0],
    hover: base$3.purple[600],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$3.purple[800]
  },
  text: {
    default: base$4.transparent[0],
    hover: base$3.purple[25],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$3.purple[50]
  },
  textInverse: {
    default: base$4.transparent[0],
    hover: base$3.purple[600],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$3.purple[800]
  }
};

// foreground means button text
var buttonForeground$3 = {
  primary: {
    default: base$4.white[0],
    hover: base$4.white[0],
    focus: base$4.white[0],
    disabled: base$4.white[0],
    pressed: base$4.white[0]
  },
  primaryInverse: {
    default: base$3.purple[700],
    hover: base$3.purple[700],
    focus: base$3.purple[700],
    disabled: base$3.grey[400],
    pressed: base$3.purple[700]
  },
  secondary: {
    default: base$3.purple[700],
    hover: base$3.purple[700],
    focus: base$3.purple[700],
    disabled: base$3.grey[400],
    pressed: base$3.purple[700]
  },
  secondaryInverse: {
    default: base$3.yellow[400],
    hover: base$3.yellow[400],
    focused: base$3.yellow[400],
    disabled: base$3.grey[400],
    pressed: base$3.yellow[400]
  },
  text: {
    default: base$3.purple[700],
    hover: base$3.purple[700],
    focus: base$3.purple[700],
    disabled: base$3.grey[400],
    pressed: base$3.purple[700]
  },
  textInverse: {
    default: base$3.yellow[400],
    hover: base$3.yellow[400],
    focused: base$3.yellow[400],
    disabled: base$3.grey[400],
    pressed: base$3.yellow[400]
  }
};
var buttonBorder$3 = {
  primary: {
    default: base$3.purple[700],
    hover: base$3.purple[600],
    focus: base$3.purple[700],
    disabled: base$3.grey[400],
    pressed: base$3.purple[800]
  },
  primaryInverse: {
    default: base$3.yellow[400],
    hover: base$3.yellow[300],
    focus: base$3.yellow[400],
    disabled: base$3.grey[50],
    pressed: base$3.yellow[500]
  },
  secondary: {
    default: base$3.purple[700],
    hover: base$3.purple[700],
    focus: base$3.purple[700],
    disabled: base$3.grey[400],
    pressed: base$3.purple[700]
  },
  secondaryInverse: {
    default: base$3.yellow[400],
    hover: base$3.yellow[400],
    focus: base$3.yellow[400],
    disabled: base$3.grey[400],
    pressed: base$3.yellow[400]
  },
  text: {
    default: base$4.transparent[0],
    hover: base$3.purple[25],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$3.purple[50]
  },
  textInverse: {
    default: base$4.transparent[0],
    hover: base$3.purple[600],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$3.purple[800]
  }
};
var semantic$3 = {
  text: text$3,
  interaction: interaction$3,
  fill: fill$3,
  background: background$3,
  border: border$3,
  buttonFill: buttonFill$3,
  buttonForeground: buttonForeground$3,
  buttonBorder: buttonBorder$3
};

var color$4 = {
  base: base$3,
  semantic: semantic$3
};

/**
 * Base Colours v3
 */
var lime = {
  900: {
    value: '#0d220b'
  },
  800: {
    value: '#154311'
  },
  700: {
    value: '#186511'
  },
  600: {
    value: '#16860b'
  },
  500: {
    value: '#0ea800'
  },
  400: {
    value: '#2ec121'
  },
  300: {
    value: '#56d94a'
  },
  200: {
    value: '#85f27c'
  },
  100: {
    value: '#abfca4'
  },
  50: {
    value: '#caffc5'
  },
  25: {
    value: '#e4ffe2'
  }
};
var navy = {
  900: {
    value: '#0e182a'
  },
  800: {
    value: '#142c54'
  },
  700: {
    value: '#25406e'
  },
  600: {
    value: '#3a5687'
  },
  500: {
    value: '#5470a1'
  },
  400: {
    value: '#748eba'
  },
  300: {
    value: '#98aed4'
  },
  200: {
    value: '#c1d2ee'
  },
  100: {
    value: '#dae5f9'
  },
  50: {
    value: '#eaf1fd'
  },
  25: {
    value: '#f4f8fe'
  }
};
var ocean = {
  900: {
    value: '#161331'
  },
  800: {
    value: '#292363'
  },
  700: {
    value: '#3b3194'
  },
  600: {
    value: '#483bc5'
  },
  500: {
    value: '#6458d7'
  },
  400: {
    value: '#857ae9'
  },
  300: {
    value: '#a89ffb'
  },
  200: {
    value: '#cdc8ff'
  },
  100: {
    value: '#e4e1ff'
  },
  50: {
    value: '#f1efff'
  },
  25: {
    value: '#f8f7ff'
  }
};
var vermillion = {
  900: {
    value: '#361712'
  },
  800: {
    value: '#6d281c'
  },
  700: {
    value: '#a3301c'
  },
  600: {
    value: '#d93013'
  },
  500: {
    value: '#e84f34'
  },
  400: {
    value: '#f8715a'
  },
  300: {
    value: '#ff9684'
  },
  200: {
    value: '#ffbeb2'
  },
  100: {
    value: '#ffd8d1'
  },
  50: {
    value: '#ffe9e5'
  },
  25: {
    value: '#fff5f3'
  }
};
var grey$1 = {
  900: {
    value: '#0f141e'
  },
  800: {
    value: '#232c3d'
  },
  700: {
    value: '#3c475b'
  },
  600: {
    value: '#556177'
  },
  500: {
    value: '#727d92'
  },
  400: {
    value: '#929cae'
  },
  300: {
    value: '#b5bcca'
  },
  200: {
    value: '#dbdee5'
  },
  100: {
    value: '#eff0f3'
  },
  50: {
    value: '#f8f8f9'
  },
  25: {
    value: '#fbfbfc'
  }
};

/**
 * Base Color v1 (LUI Now compatible)
 */

/**
 * @deprecated LUI-863 To be removed in the next major
 */
var shade$2 = _objectSpread2(_objectSpread2({
  1000: {
    value: '#000000',
    deprecated: true,
    deprecated_comment: 'Replace with the "black" color. Will be removed in next major.'
  },
  950: {
    value: '#0B0B0B',
    deprecated: true,
    deprecated_comment: 'Replace with the "grey" color. Will be removed in next major.'
  }
}, grey$1), {}, {
  0: {
    value: '#FFFFFF',
    deprecated: true,
    deprecated_comment: 'Replace with the "white" color. Will be removed in next major.'
  }
});

/**
 * @deprecated LUI-863 To be removed in the next major
 */
var primary$1 = _objectSpread2({
  950: {
    value: lime['900'].value,
    deprecated: true,
    deprecated_comment: 'Replace with the "lime" color. Will be removed in next major.'
  }
}, lime);

/**
 * @deprecated LUI-863 To be removed in the next major
 */
var secondary$1 = _objectSpread2({
  950: {
    value: navy['900'].value,
    deprecated: true,
    deprecated_comment: 'Replace with the "navy" color. Will be removed in next major.'
  }
}, navy);

/**
 * @deprecated LUI-863 To be removed in the next major
 */
var tertiary$1 = _objectSpread2({
  950: {
    value: ocean['900'].value,
    deprecated: true,
    deprecated_comment: 'Replace with the "ocean" color. Will be removed in next major.'
  }
}, ocean);
var base$2 = {
  primary: primary$1,
  secondary: secondary$1,
  tertiary: tertiary$1,
  lime,
  navy,
  ocean,
  vermillion,
  grey: grey$1,
  shade: shade$2
};

var text$2 = {
  main: base$2.grey[900],
  subtle: base$2.grey[700],
  contrast: base$2.navy[800],
  inverse: base$4.white[0],
  default: base$2.grey[900]
};
var interaction$2 = {
  main: base$2.lime[500],
  subtle: base$4.white[0],
  contrast: base$2.lime[500],
  emphasis: base$2.vermillion[600],
  disabled: base$2.grey[400],
  success: base$4.green[600],
  error: base$4.red[600]
};
var fill$2 = {
  main: base$4.white[0],
  contrast: base$2.navy[800],
  accent: base$2.lime[500],
  selected: base$2.navy[50],
  disabled: base$2.grey[50]
};
var background$2 = {
  page: base$2.grey[25],
  container: base$4.white[0],
  surface: base$2.grey[100],
  emphasis: base$2.grey[50]
};
var border$2 = {
  container: base$2.grey[200],
  divider: base$2.grey[100],
  dividerEmphasis: base$2.grey[900],
  interaction: {
    default: base$2.grey[500],
    hover: base$2.grey[700],
    focus: base$4.ultramarine[500],
    selected: base$2.navy[800]
  }
};
var buttonFill$2 = {
  primary: {
    default: base$2.lime[500],
    hover: base$2.lime[400],
    focus: base$2.lime[500],
    disabled: base$2.grey[400],
    pressed: base$2.lime[600]
  },
  primaryInverse: {
    default: base$4.white[0],
    hover: base$2.lime[25],
    focus: base$4.white[0],
    disabled: base$2.grey[50],
    pressed: base$2.lime[50]
  },
  secondary: {
    default: base$4.transparent[0],
    hover: base$2.lime[25],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$2.lime[50]
  },
  secondaryInverse: {
    default: base$4.transparent[0],
    hover: base$2.navy[700],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$2.navy[900]
  },
  text: {
    default: base$4.transparent[0],
    hover: base$2.lime[25],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$2.lime[50]
  },
  textInverse: {
    default: base$4.transparent[0],
    hover: base$2.navy[700],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$2.navy[900]
  }
};
var buttonForeground$2 = {
  primary: {
    default: base$4.white[0],
    // todo: white
    hover: base$4.white[0],
    // todo: white
    focus: base$4.white[0],
    // todo: white
    disabled: base$4.white[0],
    pressed: base$4.white[0] // todo: white
  },

  primaryInverse: {
    default: base$2.lime[500],
    hover: base$2.lime[500],
    focused: base$2.lime[500],
    disabled: base$2.grey[400],
    pressed: base$2.lime[500]
  },
  secondary: {
    default: base$2.lime[500],
    hover: base$2.lime[500],
    focused: base$2.lime[500],
    disabled: base$2.grey[400],
    pressed: base$2.lime[500]
  },
  secondaryInverse: {
    default: base$4.white[0],
    hover: base$4.white[0],
    focused: base$4.white[0],
    disabled: base$2.grey[400],
    pressed: base$4.white[0]
  },
  text: {
    default: base$2.lime[500],
    hover: base$2.lime[500],
    focused: base$2.lime[500],
    disabled: base$2.grey[400],
    pressed: base$2.lime[500]
  },
  textInverse: {
    default: base$4.white[0],
    hover: base$4.white[0],
    focused: base$4.white[0],
    disabled: base$2.grey[400],
    pressed: base$4.white[0]
  }
};
var buttonBorder$2 = {
  primary: {
    default: base$2.lime[500],
    hover: base$2.lime[400],
    focus: base$2.lime[500],
    disabled: base$2.grey[400],
    pressed: base$2.lime[600]
  },
  primaryInverse: {
    default: base$4.white[0],
    hover: base$2.lime[25],
    focus: base$4.white[0],
    disabled: base$2.grey[50],
    pressed: base$2.lime[50]
  },
  secondary: {
    default: base$2.lime[500],
    hover: base$2.lime[500],
    focus: base$2.lime[500],
    disabled: base$2.grey[400],
    pressed: base$2.lime[500]
  },
  secondaryInverse: {
    default: base$4.white[0],
    focus: base$4.white[0],
    hover: base$4.white[0],
    pressed: base$4.white[0],
    disabled: base$2.grey[400]
  },
  text: {
    default: base$4.transparent[0],
    hover: base$2.lime[25],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$2.lime[50]
  },
  textInverse: {
    default: base$4.transparent[0],
    hover: base$2.navy[700],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$2.navy[900]
  }
};
var semantic$2 = {
  text: text$2,
  interaction: interaction$2,
  fill: fill$2,
  background: background$2,
  border: border$2,
  buttonFill: buttonFill$2,
  buttonForeground: buttonForeground$2,
  buttonBorder: buttonBorder$2
};

var color$3 = {
  base: base$2,
  semantic: semantic$2
};

/**
 * Base Colours v1 (LUI Now)
 *
 * @see https://www.figma.com/file/tgquIt0gPjaosYSGkjm5IQ/Colours---Base-%26-Semantic?node-id=207%3A20457
 */

/**
 * @deprecated Use `turquoise` instead. LUI-863 To be removed in the next major
 */
var primary = {
  950: {
    value: '#001310'
  },
  900: {
    value: '#002621'
  },
  800: {
    value: '#004C42'
  },
  700: {
    value: '#007363'
  },
  600: {
    value: '#329984'
  },
  500: {
    value: '#00C0A5'
  },
  400: {
    value: '#32CCB7'
  },
  300: {
    value: '#66D9C9'
  },
  200: {
    value: '#99E5DB'
  },
  100: {
    value: '#CCF2ED'
  },
  50: {
    value: '#E5F8F6'
  },
  25: {
    value: '#F2FBFA'
  }
};

/**
 @deprecated Use `turquoise` instead. LUI-863 To be removed in the next major
 */
var secondary = {
  950: {
    value: '#01080A'
  },
  900: {
    value: '#021215'
  },
  800: {
    value: '#05242B'
  },
  700: {
    value: '#073641'
  },
  600: {
    value: '#0A4857'
  },
  500: {
    value: '#0D5A6D'
  },
  400: {
    value: '#3D7A8A'
  },
  300: {
    value: '#6D9CA7'
  },
  200: {
    value: '#9EBDC4'
  },
  100: {
    value: '#CEDEE1'
  },
  50: {
    value: '#E6EEF0'
  },
  25: {
    value: '#F2F6F7'
  }
};

/**
 @deprecated Use `turquoise` instead. LUI-863 To be removed in the next major
 */
var tertiary = {
  950: {
    value: '#190B09'
  },
  900: {
    value: '#331613'
  },
  800: {
    value: '#662C27'
  },
  700: {
    value: '#99433B'
  },
  600: {
    value: '#CC594F'
  },
  500: {
    value: '#FF7063'
  },
  400: {
    value: '#FF8C82'
  },
  300: {
    value: '#FFA9A1'
  },
  200: {
    value: '#FFC5C0'
  },
  100: {
    value: '#FFE2DF'
  },
  50: {
    value: '#FFF0EF'
  },
  25: {
    value: '#FFF7F7'
  }
};

/**
 * Base Color v1 (LUI Now compatible)
 * @deprecated LUI-863 To be removed in the next major
 */
var shade$1 = {
  1000: {
    value: '#000000'
  },
  950: {
    value: '#0B0B0B'
  },
  900: {
    value: '#171717'
  },
  800: {
    value: '#2F2F2F'
  },
  700: {
    value: '#474747'
  },
  600: {
    value: '#5F5F5F'
  },
  500: {
    value: '#777777'
  },
  400: {
    value: '#929292'
  },
  300: {
    value: '#ADADAD'
  },
  200: {
    value: '#C8C8C8'
  },
  100: {
    value: '#E3E3E3'
  },
  50: {
    value: '#F1F1F1'
  },
  25: {
    value: '#F8F8F8'
  },
  0: {
    value: '#FFFFFF'
  }
};
var base$1 = {
  primary,
  secondary,
  tertiary,
  shade: shade$1
};

var interaction$1 = {
  main: base$1.primary[500],
  subtle: base$4.white[0],
  contrast: base$1.primary[500],
  emphasis: base$1.tertiary[500],
  disabled: base$1.shade[700],
  success: base$4.success[500],
  error: base$4.error[500]
};
var background$1 = {
  page: base$1.shade[25],
  container: base$4.white[0],
  surface: base$1.shade[100],
  emphasis: base$1.shade[50]
};
var text$1 = {
  main: base$1.shade[700],
  subtle: base$1.shade[600],
  inverse: base$4.white[0],
  contrast: base$1.secondary[500]
};
var fill$1 = {
  main: base$4.white[0],
  selected: base$1.primary[50],
  disabled: base$1.shade[25],
  accent: base$1.primary[500],
  contrast: base$1.secondary[500]
};
var border$1 = {
  container: base$1.shade[100],
  divider: base$1.shade[300],
  dividerEmphasis: base$1.shade[800],
  interaction: {
    default: base$1.shade[200],
    hover: base$1.secondary[500],
    selected: interaction$1.contrast,
    focus: {
      value: '#3F86F7'
    }
  }
};
var buttonFill$1 = {
  primary: {
    default: base$1.primary[500],
    hover: base$1.primary[400],
    focus: base$1.primary[600],
    disabled: base$1.primary[500],
    pressed: base$1.primary[600]
  },
  primaryInverse: {
    default: interaction$1.emphasis,
    hover: base$4.white[0],
    focus: interaction$1.emphasis,
    disabled: fill$1.disabled,
    pressed: interaction$1.emphasis
  },
  secondary: {
    default: base$4.white[0],
    hover: base$4.white[0],
    focus: base$4.white[0],
    disabled: base$4.white[0],
    pressed: base$1.primary[50]
  },
  secondaryInverse: {
    default: base$4.transparent[0],
    hover: base$4.white[0],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$1.primary[50]
  },
  text: {
    default: base$4.transparent[0],
    hover: base$4.transparent[0],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$4.transparent[0]
  },
  textInverse: {
    default: base$4.transparent[0],
    hover: base$4.transparent[0],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$4.transparent[0]
  }
};
var buttonForeground$1 = {
  primary: {
    default: base$4.white[0],
    hover: base$4.white[0],
    focus: base$4.white[0],
    disabled: base$4.white[0],
    pressed: base$4.white[0]
  },
  primaryInverse: {
    default: base$4.white[0],
    hover: interaction$1.emphasis,
    focused: base$4.white[0],
    disabled: interaction$1.disabled,
    pressed: base$4.white[0]
  },
  secondary: {
    default: interaction$1.main,
    hover: interaction$1.main,
    focus: interaction$1.main,
    disabled: interaction$1.main,
    pressed: base$1.primary[600]
  },
  secondaryInverse: {
    default: base$4.white[0],
    hover: interaction$1.main,
    focused: base$4.white[0],
    disabled: base$4.white[0],
    pressed: base$1.primary[600]
  },
  text: {
    default: interaction$1.main,
    hover: interaction$1.main,
    focus: interaction$1.main,
    disabled: interaction$1.main,
    pressed: base$1.primary[600]
  },
  textInverse: {
    default: base$4.white[0],
    hover: interaction$1.main,
    focus: base$4.white[0],
    disabled: base$4.white[0],
    pressed: base$4.white[0]
  }
};
var buttonBorder$1 = {
  primary: {
    default: base$4.transparent[0],
    hover: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$4.transparent[0]
  },
  primaryInverse: {
    pressed: interaction$1.emphasis,
    default: interaction$1.emphasis,
    hover: base$4.white[0],
    focus: interaction$1.emphasis,
    disabled: base$1.shade[700]
  },
  secondary: {
    default: interaction$1.main,
    hover: base$1.primary[400],
    focus: interaction$1.main,
    disabled: interaction$1.main,
    pressed: base$1.primary[600]
  },
  secondaryInverse: {
    default: base$4.white[0],
    hover: interaction$1.main,
    focus: base$4.white[0],
    disabled: base$4.white[0],
    pressed: base$1.primary[600]
  },
  text: {
    default: base$4.transparent[0],
    hover: base$4.transparent[0],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$4.transparent[0]
  },
  textInverse: {
    default: base$4.transparent[0],
    hover: base$4.transparent[0],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base$4.transparent[0]
  }
};
var semantic$1 = {
  text: text$1,
  interaction: interaction$1,
  fill: fill$1,
  background: background$1,
  border: border$1,
  buttonFill: buttonFill$1,
  buttonForeground: buttonForeground$1,
  buttonBorder: buttonBorder$1
};

var color$2 = {
  base: base$1,
  semantic: semantic$1
};

/**
 * Base Colours v3
 */
var tiber = {
  900: {
    value: '#091d21'
  },
  800: {
    value: '#083742'
  },
  700: {
    value: '#15505d'
  },
  600: {
    value: '#296a79'
  },
  500: {
    value: '#428594'
  },
  400: {
    value: '#61a1b0'
  },
  300: {
    value: '#85becb'
  },
  200: {
    value: '#b0dce6'
  },
  100: {
    value: '#cdedf4'
  },
  50: {
    value: '#e0f5fa'
  },
  25: {
    value: '#f0fafc'
  }
};
var turquoise = {
  900: {
    value: '#0b201d'
  },
  800: {
    value: '#12403a'
  },
  700: {
    value: '#146056'
  },
  600: {
    value: '#128071'
  },
  500: {
    value: '#0ba08b'
  },
  400: {
    value: '#00c0a5'
  },
  300: {
    value: '#2bd9c2'
  },
  200: {
    value: '#60f1dd'
  },
  100: {
    value: '#8efced'
  },
  50: {
    value: '#b7fff5'
  },
  25: {
    value: '#dbfffa'
  }
};
var lagoon = {
  900: {
    value: '#0b1e23'
  },
  800: {
    value: '#0f3a46'
  },
  700: {
    value: '#0b5569'
  },
  600: {
    value: '#006e8c'
  },
  500: {
    value: '#1987a5'
  },
  400: {
    value: '#39a1be'
  },
  300: {
    value: '#60bdd7'
  },
  200: {
    value: '#8fdbf0'
  },
  100: {
    value: '#b3ebfb'
  },
  50: {
    value: '#cff5ff'
  },
  25: {
    value: '#e7faff'
  }
};
var coral = {
  900: {
    value: '#2b1412'
  },
  800: {
    value: '#552723'
  },
  700: {
    value: '#803a34'
  },
  600: {
    value: '#aa4c44'
  },
  500: {
    value: '#d45e54'
  },
  400: {
    value: '#ff7063'
  },
  300: {
    value: '#ff978d'
  },
  200: {
    value: '#ffc0ba'
  },
  100: {
    value: '#ffdad7'
  },
  50: {
    value: '#ffebe9'
  },
  25: {
    value: '#fff6f5'
  }
};
var grey = {
  900: {
    value: '#181818'
  },
  800: {
    value: '#2f2f2f'
  },
  700: {
    value: '#474747'
  },
  600: {
    value: '#656565'
  },
  500: {
    value: '#838383'
  },
  400: {
    value: '#a1a1a1'
  },
  300: {
    value: '#bfbfbf'
  },
  200: {
    value: '#dcdcdc'
  },
  100: {
    value: '#ececec'
  },
  50: {
    value: '#f5f5f5'
  },
  25: {
    value: '#fafafa'
  }
};

/**
 * Base Color v1 (LUI Now compatible)
 * @deprecated use `grey` instead. LUI-863 To be removed in the next major
 */
var shade = _objectSpread2(_objectSpread2({
  1000: {
    value: '#000000'
  },
  950: {
    value: '#0B0B0B'
  }
}, grey), {}, {
  0: {
    value: '#FFFFFF'
  }
});
var base = {
  tiber,
  turquoise,
  lagoon,
  coral,
  grey,
  shade
};

var text = {
  main: base.grey[900],
  subtle: base.grey[700],
  contrast: base.tiber[800],
  inverse: base$4.white[0]
};
var interaction = {
  main: base.lagoon[600],
  subtle: base$4.white[0],
  contrast: base.turquoise[500],
  emphasis: base.coral[400],
  disabled: base.grey[400],
  success: base$4.green[600],
  error: base$4.red[600]
};
var fill = {
  main: base$4.white[0],
  contrast: base.lagoon[600],
  accent: base.turquoise[400],
  selected: base.lagoon[50],
  disabled: base.grey[50]
};
var background = {
  page: base.grey[25],
  container: base$4.white[0],
  surface: base.grey[100],
  emphasis: base.grey[50]
};
var border = {
  container: base.grey[200],
  divider: base.grey[100],
  dividerEmphasis: base.grey[900],
  interaction: {
    default: base.grey[500],
    hover: base.grey[700],
    focus: base$4.ultramarine[500],
    selected: base.lagoon[600]
  }
};
var buttonFill = {
  primary: {
    default: base.lagoon[600],
    hover: base.lagoon[700],
    focus: base.lagoon[600],
    disabled: base.grey[400],
    pressed: base.lagoon[800]
  },
  primaryInverse: {
    default: base$4.white[0],
    hover: base.lagoon[25],
    focus: base$4.white[0],
    disabled: base.grey[50],
    pressed: base.lagoon[50]
  },
  secondary: {
    default: base$4.transparent[0],
    hover: base.lagoon[25],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base.lagoon[50]
  },
  secondaryInverse: {
    default: base$4.transparent[0],
    hover: base.tiber[700],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base.tiber[900]
  },
  text: {
    default: base$4.transparent[0],
    hover: base.lagoon[25],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base.lagoon[50]
  },
  textInverse: {
    default: base$4.transparent[0],
    hover: base.tiber[700],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base.tiber[900]
  }
};
var buttonForeground = {
  primary: {
    default: base$4.white[0],
    hover: base$4.white[0],
    disabled: base$4.white[0],
    pressed: base$4.white[0]
  },
  primaryInverse: {
    default: base.lagoon[600],
    hover: base.lagoon[600],
    focus: base.lagoon[600],
    disabled: base.grey[400],
    pressed: base.lagoon[600]
  },
  secondary: {
    default: base.lagoon[600],
    hover: base.lagoon[600],
    focus: base.lagoon[600],
    disabled: base.grey[400],
    pressed: base.lagoon[600]
  },
  secondaryInverse: {
    default: base$4.white[0],
    hover: base$4.white[0],
    focus: base$4.white[0],
    disabled: base.grey[400],
    pressed: base$4.white[0]
  },
  text: {
    default: base.lagoon[600],
    hover: base.lagoon[600],
    focus: base.lagoon[600],
    disabled: base.grey[400],
    pressed: base.lagoon[600]
  },
  textInverse: {
    default: base$4.white[0],
    hover: base$4.white[0],
    focus: base$4.white[0],
    disabled: base.grey[400],
    pressed: base$4.white[0]
  }
};
var buttonBorder = {
  primary: {
    default: base.lagoon[600],
    hover: base.lagoon[700],
    focus: base.lagoon[600],
    disabled: base.grey[400],
    pressed: base.lagoon[800]
  },
  primaryInverse: {
    default: base$4.white[0],
    hover: base.lagoon[25],
    focus: base$4.white[0],
    disabled: base.grey[50],
    pressed: base.lagoon[50]
  },
  secondary: {
    default: base.lagoon[600],
    hover: base.lagoon[600],
    focus: base.lagoon[600],
    disabled: base.grey[400],
    pressed: base.lagoon[600]
  },
  secondaryInverse: {
    default: base$4.white[0],
    focus: base$4.white[0],
    hover: base$4.white[0],
    pressed: base$4.white[0],
    disabled: base.grey[400]
  },
  text: {
    default: base$4.transparent[0],
    hover: base.lagoon[25],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base.lagoon[50]
  },
  textInverse: {
    default: base$4.transparent[0],
    hover: base.tiber[700],
    focus: base$4.transparent[0],
    disabled: base$4.transparent[0],
    pressed: base.tiber[900]
  }
};
var semantic = {
  text,
  interaction,
  fill,
  background,
  border,
  buttonFill,
  buttonForeground,
  buttonBorder
};

var color$1 = {
  base,
  semantic
};

var color = {
  common: color$5,
  lendi: color$2,
  lendiNext: color$1,
  domain: color$3,
  aussie: color$4
};

function select(path) {
  return _ref => {
    var {
      colors
    } = _ref;
    if (!colors) {
      throw new Error('@lendi-ui/theme: Theme not found. Please ensure your components are wrapped in the Theme component e.g. <Theme><App/></Theme>');
    }
    var pathWithDesignToken = "".concat(path, ".value");
    var obj = colors;
    var startIndex = -1;
    var finishIndex = -1;
    do {
      // check if there is a key that matches the remainder of the path
      var restOfPath = pathWithDesignToken.substr(startIndex + 1);
      if (Object.prototype.hasOwnProperty.call(obj, restOfPath)) {
        return obj[restOfPath];
      }

      // check if there is a key that matches the next part of the path
      finishIndex = pathWithDesignToken.indexOf('.', startIndex + 1);
      var nextPartOfPath = pathWithDesignToken.substr(startIndex + 1, finishIndex - startIndex - 1);
      if (finishIndex === -1 || !Object.prototype.hasOwnProperty.call(obj, nextPartOfPath)) {
        // console.warn(`@lendi-ui/commons: getColour(${path}) Could not find a matching color.`);
        return undefined;
      }
      obj = obj[nextPartOfPath];
      startIndex = finishIndex;
    } while (true); // eslint-disable-line no-constant-condition
  };
}

var isHex = str => str.match(/^#(?:[0-9a-fA-F]{3}){1,2}$/);
var createErrorString = (category, key, theme, state) => {
  var message = "The colour ".concat(category, ", ").concat(key, ",");
  if (state) {
    message = "".concat(message, ", ").concat(state, ",");
  }
  message = "".concat(message, " does not exist");
  if (theme) {
    message = "".concat(message, " for theme: ").concat(theme);
  }
  return message;
};
function getColour(category, key, options) {
  var _options$theme;
  var hex;
  var state = options === null || options === void 0 ? void 0 : options.state;
  var themeName = (_options$theme = options === null || options === void 0 ? void 0 : options.theme) !== null && _options$theme !== void 0 ? _options$theme : getThemeName();
  var themePalette = _objectSpread2(_objectSpread2({}, color.lendi.base), color.lendi.semantic);
  switch (themeName) {
    case ThemeNames.Lendi:
      themePalette = _objectSpread2(_objectSpread2({}, color.lendi.base), color.lendi.semantic);
      break;
    case ThemeNames.LendiNext:
      themePalette = _objectSpread2(_objectSpread2({}, color.lendiNext.base), color.lendiNext.semantic);
      break;
    case ThemeNames.Domain:
      themePalette = _objectSpread2(_objectSpread2({}, color.domain.base), color.domain.semantic);
      break;
    case ThemeNames.Aussie:
      themePalette = _objectSpread2(_objectSpread2({}, color.aussie.base), color.aussie.semantic);
      break;
  }
  var merged = _objectSpread2(_objectSpread2({}, color.common.base), themePalette);
  if (category === 'border' || category === 'buttonFill' || category === 'buttonForeground' || category === 'buttonBorder') {
    // Border is a special semantic where we had nested semantic before.
    if (state) {
      hex = select("".concat(category, ".").concat(key, ".").concat(state))({
        colors: merged
      });
    } else {
      var _select;
      hex = (_select = select("".concat(category, ".").concat(key))({
        colors: merged
      })) !== null && _select !== void 0 ? _select : select("".concat(category, ".").concat(key, ".default"))({
        colors: merged
      });
    }
  } else {
    hex = select("".concat(category, ".").concat(key))({
      colors: merged
    });
  }
  if (!hex) {
    console.warn(createErrorString(category, key, themeName, options === null || options === void 0 ? void 0 : options.state));
  }
  return hex;
}

export { color as c, getColour as g, isHex as i };
